import { z } from "zod";

export const nameSchema = z.object({
  name: z.string().min(1, "Name is required"),
  username: z.string().optional(),
  email: z.string().optional(),
});

export const passwordSchema = z
  .object({
    currentPassword: z.string().min(1, "Current password is required"),
    newPassword: z
      .string()
      .min(8, "New password must be at least 8 characters")
      .max(64, "Password must not exceed 64 characters")
      .regex(/[a-z]/, "Password must contain at least one lowercase letter")
      .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
      .regex(/\d/, "Password must contain at least one digit")
      .regex(/[^A-Za-z0-9]/, "Password must contain at least one special character"),
    confirmPassword: z.string().min(1, "Confirm your new password"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords do not match",
    path: ["confirmPassword"],
  });

export const nameDefaultValue = {
  name: "",
  username: "",
  email: "",
};

export const passwordDefaultValue = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};
